import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Income = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm0 20c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9Z" />
    <path d="M12.292 10.854c-.876-.21-1.452-.373-1.452-.68 0-.412.48-.7 1.168-.7.9 0 1.55.403 1.856.779a.5.5 0 0 0 .803-.039l.547-.82a.5.5 0 0 0-.06-.628c-.568-.576-1.306-.963-2.154-1.134V6c0-.551-.449-1-1-1-.551 0-1 .449-1 1v1.628c-1.391.318-2.297 1.313-2.297 2.578 0 1.982 1.874 2.421 3.131 2.716 1.039.259 1.528.424 1.528.818 0 .751-.978.81-1.277.81-.91 0-1.709-.46-2.097-.913a.5.5 0 0 0-.788.034l-.607.852a.5.5 0 0 0 .04.631c.61.656 1.405 1.075 2.367 1.25V18a1.001 1.001 0 0 0 2 0v-1.586c1.534-.295 2.5-1.321 2.5-2.705 0-2.119-1.931-2.562-3.208-2.855Z" />
  </SvgIcon>
);

export default Income;
